import { atom } from "jotai";

export const UserLoggedAtom = atom<boolean>(false);
